import { UserAuthWrapper } from 'redux-auth-wrapper';

import {
    loadingBinderSelector,
    binderPermissionsSelector,
    binderMenuPermissionsSelector
} from 'common/permissions/selectors';

import {
    manageInternalUsersMenuPredicate,
    manageExternalUsersMenuPredicate,
    editBinderDetailsMenuPredicate,
    editBinderQueryMenuPredicate,
    editBinderDetailsPredicate,
    timelineMenuPredicate,
    compileMenuPredicate,
} from 'common/permissions/predicates';

export const UserCanSeeInternalUsers = UserAuthWrapper({
    authSelector: binderMenuPermissionsSelector,
    authenticatingSelector: loadingBinderSelector,
    predicate: manageInternalUsersMenuPredicate,
    FailureComponent: null
});

export const UserCanSeeExternalUsers = UserAuthWrapper({
    authSelector: binderMenuPermissionsSelector,
    authenticatingSelector: loadingBinderSelector,
    predicate: manageExternalUsersMenuPredicate,
    FailureComponent: null
});

export const UserCanEditBinderDetails = UserAuthWrapper({
    authSelector: binderPermissionsSelector,
    authenticatingSelector: loadingBinderSelector,
    predicate: editBinderDetailsPredicate,
    FailureComponent: null
});

export const UserCanSeeBinderDetails = UserAuthWrapper({
    authSelector: binderMenuPermissionsSelector,
    authenticatingSelector: loadingBinderSelector,
    predicate: editBinderDetailsMenuPredicate,
    FailureComponent: null
});

export const UserCanSeeBinderSetup = UserAuthWrapper({
    authSelector: binderMenuPermissionsSelector,
    authenticatingSelector: loadingBinderSelector,
    predicate: editBinderQueryMenuPredicate,
    FailureComponent: null
});

export const UserCanSeeBinderTimeline = UserAuthWrapper({
    authSelector: binderMenuPermissionsSelector,
    authenticatingSelector: loadingBinderSelector,
    predicate: timelineMenuPredicate,
    FailureComponent: null
});

export const UserCanCompileBinder = UserAuthWrapper({
    authSelector: binderMenuPermissionsSelector,
    authenticatingSelector: loadingBinderSelector,
    predicate: compileMenuPredicate,
    FailureComponent: null
});

export const UserCanSeeUnfiledDocuments = UserAuthWrapper({
    authSelector: binderPermissionsSelector,
    authenticatingSelector: loadingBinderSelector,
    predicate: binderPermissions => binderPermissions.unfiledDocuments,
    FailureComponent: null
});

